import classNames from "classnames";
import { isObject } from "lodash";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { TipTapBlockEditor } from "@circle-react-shared/uikit/TipTapBlockEditor";

export interface BannerContentProps {
  description?: {
    body?: object;
    sgids_to_object_map?: object;
    inline_attachments?: object[];
  };
  hasMedia?: boolean;
  title: string;
}

export const BannerContent = ({
  description,
  hasMedia = false,
  title,
}: BannerContentProps) => (
  <div
    className={classNames(
      "bg-primary border-primary rounded-none border-x border-b p-5 md:rounded-b-lg md:px-6",
      {
        "border-t md:rounded-lg": !hasMedia,
      },
    )}
  >
    {title && (
      <Typography.TitleLg data-testid="welcome-banner-title">
        {title}
      </Typography.TitleLg>
    )}
    {isObject(description) && (
      <div
        className={classNames({ "mt-5": Boolean(title) })}
        data-testid="welcome-banner-content"
      >
        <TipTapBlockEditor
          readOnly
          value={description.body}
          sgidToObjectMap={description.sgids_to_object_map}
          inlineAttachments={description.inline_attachments}
          openInternalLinksInCurrentTab
          shouldRefetch
          disabledExtensions={["cta"]}
        />
      </div>
    )}
  </div>
);
